import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/app/clients/fiu-portal/layouts/default.vue").then(m => m.default || m)),
  full: defineAsyncComponent(() => import("/usr/src/app/clients/fiu-portal/layouts/full.vue").then(m => m.default || m))
}